import { css } from 'styled-components';
import { rgba } from 'polished';

// CONSTANTS
import { MAIN_BLACK } from '@/constants/colors';

export const showLogoBackground = css`
  &::before {
    content: '';
    position: absolute;
    bottom: -1px;
    width: 100%;
    height: 100%;
    display: block;

    transform: matrix(1, 0, 0, -1, 0, 0);
    background-image: linear-gradient(180deg, ${MAIN_BLACK} 17.81%, ${rgba(MAIN_BLACK, 0)} 100%);
  }
`;

export default { showLogoBackground };
